'use strict';

require('@babel/polyfill');